import { Box, Button, HStack, Input, Text, VStack } from "@chakra-ui/react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { resolvePrismicLink } from "utils/prismicLinks";
import { ACCENT, HERO_BG, HOME_HERO_ORBS, heroGradientBoxProps } from "./heroBackground";

// Help-section-only UI, not driven by Prismic content — `searchValue`/`onSearchChange`
// are only passed by HelpPage.jsx (the Help section's hero), so this renders on every
// Help page without needing a field on the home_hero slice model.
export default function HomeHeroSlice({ slice, onNavigate, searchValue, onSearchChange }) {
  const { lozenge, primary_heading, secondary_heading, body_text, cta } = slice.primary;
  const ctaLink = cta?.[0];
  const resolved = ctaLink && resolvePrismicLink(ctaLink);

  return (
    <Box
      {...heroGradientBoxProps}
      pt={{ base: "48px", md: "80px" }}
      pb={{ base: "80px", md: "96px" }}
      px={6}
      color="white"
      textAlign="center"
    >
      {HOME_HERO_ORBS.map((orbProps, i) => (
        <Box key={i} {...orbProps} />
      ))}
      <VStack position="relative" zIndex={1} gap={4} maxW="768px" mx="auto">
        {lozenge && (
          <Text
            display="inline-block"
            px={3}
            py={1.5}
            fontSize="12px"
            fontWeight="500"
            bg={`${ACCENT}1A`}
            color={ACCENT}
            borderRadius="full"
          >
            {lozenge}
          </Text>
        )}
        {primary_heading && (
          <Text
            fontSize={{ base: "36px", md: "60px", lg: "72px" }}
            fontWeight="700"
            letterSpacing="tight"
            lineHeight="1.1"
            color="white"
          >
            {primary_heading}
          </Text>
        )}
        {secondary_heading && (
          <Text fontSize={{ base: "20px", md: "24px" }} color={ACCENT} fontWeight="600">
            {secondary_heading}
          </Text>
        )}
        {body_text && (
          <Text fontSize={{ base: "18px", md: "20px" }} color="whiteAlpha.900">
            {body_text}
          </Text>
        )}
        {resolved?.kind === "internal" && (
          <Button bg={ACCENT} color={HERO_BG} fontWeight="600" _hover={{ bg: ACCENT, opacity: 0.9 }} mt={2} onClick={() => onNavigate(resolved.uid)}>
            {ctaLink.text || "Learn more"}
          </Button>
        )}
        {resolved?.kind === "external" && (
          <Button
            as="a"
            href={resolved.url}
            target="_blank"
            rel="noopener noreferrer"
            bg={ACCENT}
            color={HERO_BG}
            fontWeight="600"
            _hover={{ bg: ACCENT, opacity: 0.9 }}
            mt={2}
          >
            {ctaLink.text || "Learn more"}
          </Button>
        )}
        {onSearchChange && (
          <HStack bg="whiteAlpha.100" border="1px solid" borderColor="whiteAlpha.300" borderRadius="full" px={4} py={2} mt={4} w="100%" maxW="480px">
            <MagnifyingGlass size={18} color="white" />
            <Input
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search help articles..."
              variant="unstyled"
              color="white"
              _placeholder={{ color: "whiteAlpha.700" }}
            />
          </HStack>
        )}
      </VStack>
    </Box>
  );
}
